export default class Debug {

    write( message, type = 'default' ) {
        if ( themeVars.debug !== undefined && themeVars.debug === '1' ) {
            var style = 'background: #59bcf0; font-weight: bold; color: #fff',
                prefix = ' Info: ';

            switch ( type ) {
                case 'error':
                    prefix = ' Error: '
                    style = 'background: #ed1111; font-weight: bold; color: #fff';
                    break;
                case 'success':
                    prefix = ' Success: '
                    style = 'background: #43d896; font-weight: bold; color: #fff';
                    break;
            }

            console.log( '%c ' + prefix + message + ' ', style );
        }
    }

}
